// ChatReminderNotification.js
import { useEffect, useState } from "react";
import { socket } from "./Pages/Support"; // Ensure the socket is properly initialized in Support
import { Link } from "react-router-dom";
import "./App.css"; // Ensure this contains required styles for overlay & popup

const ChatReminderNotification = () => {
  const [reminder, setReminder] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Listen to socket event
    const handleNotification = (data) => {
      setReminder(data);
      setShow(true);
      document.body.style.overflow = "hidden"; // Prevent background scroll
    };

    socket.on("dashboardNotification", handleNotification);

    return () => {
      socket.off("dashboardNotification", handleNotification);
      document.body.style.overflow = "auto";
    };
  }, []);

  const handleClose = () => {
    setShow(false);
    document.body.style.overflow = "auto";
  };

  if (!show || !reminder) return null;

  const formattedTime = reminder.timestamp
    ? new Date(reminder.timestamp).toLocaleString()
    : "Unknown time";

  return (
    <div className="reminder-overlay">
      <div className="reminder-popup">
        <button className="close-btn" onClick={handleClose}>
          ×
        </button>
        <h4>🕒 Reminder Notification</h4>
        <p>
          <strong>{reminder.from}</strong> has scheduled a chat at{" "}
          <strong>{formattedTime}</strong>.
        </p>
        <Link
          to={`/support/${reminder.caseId}`}
          className="btn btn-sm btn-primary"
          onClick={handleClose}
        >
          Join Chat Room
        </Link>
      </div>
    </div>
  );
};

export default ChatReminderNotification;
